import { useNavigate } from "react-router-dom"
import AdminLayout from "./admin-layout"
import { authStore } from "@/routes/login/auth-store"
import { useEffect } from "react"
import { toast } from "sonner"

const AdminPages = () => {
  const navigate = useNavigate()
  const { role } = authStore()

  useEffect(() => {
    if (role !== "ADMIN") {
      toast.error("관리자만 접근할 수 있는 페이지입니다.")
      navigate("/", { replace: true })
    }
  }, [role, navigate])

  if (role !== "ADMIN") return null

  return <AdminLayout />
}

export default AdminPages
